// // utils/dateUtils.js
// // Sunucu tarihleri İstanbul saatiyle (duvar saati) üretir ancak Flask bunları
// // "Sun, 11 Oct 2026 23:43:22 GMT" biçiminde döndürür. new Date() bunu UTC sanıp
// // tarayıcı saatine çevirdiği için ekranda +3 saat kayma oluşur.
// // parseServerDate bu değeri, saat dilimi dönüşümü yapmadan olduğu gibi okur.

// const MONTHS = {
//   jan: 0,
//   feb: 1,
//   mar: 2,
//   apr: 3,
//   may: 4,
//   jun: 5,
//   jul: 6,
//   aug: 7,
//   sep: 8,
//   oct: 9,
//   nov: 10,
//   dec: 11,
// };

// const RFC_RE =
//   /^[A-Za-z]{3},\s*(\d{1,2})\s+([A-Za-z]{3})\s+(\d{4})\s+(\d{2}):(\d{2}):(\d{2})\s*(?:GMT|UTC)?$/;
// const SQL_RE = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/;

// // Her zaman bir Date döner; çözülemezse Invalid Date (isNaN(d.getTime()) kontrolleri çalışır).
// export function parseServerDate(input) {
//   if (input instanceof Date) return input;
//   if (input === null || input === undefined || input === "") {
//     return new Date(NaN);
//   }
//   const s = String(input).trim();

//   let m = RFC_RE.exec(s);
//   if (m) {
//     const month = MONTHS[m[2].toLowerCase()];
//     if (month !== undefined) {
//       return new Date(+m[3], month, +m[1], +m[4], +m[5], +m[6]);
//     }
//   }

//   m = SQL_RE.exec(s);
//   if (m) {
//     return new Date(
//       +m[1],
//       +m[2] - 1,
//       +m[3],
//       +(m[4] || 0),
//       +(m[5] || 0),
//       +(m[6] || 0),
//     );
//   }

//   // Zaman dilimi içeren ISO ("...Z", "+03:00") ve diğer biçimler
//   return new Date(s);
// }

// // ─────────────────────────────────────────────────────────────
// // Merkezi düzeltme: API'den gelen TÜM yanıtlarda "Sun, 11 Oct 2026 23:43:22 GMT"
// // biçimindeki tarihleri "2026-10-11T23:43:22" (saat dilimsiz → tarayıcıda yerel
// // saat) biçimine çevirir. Böylece hiçbir ekranda new Date() +3 saat kaydırmaz.
// // ─────────────────────────────────────────────────────────────
// const RFC_FULL =
//   /^[A-Za-z]{3}, (\d{1,2}) ([A-Za-z]{3}) (\d{4}) (\d{2}):(\d{2}):(\d{2}) GMT$/;

// export function normalizeServerDates(value) {
//   if (typeof value === "string") {
//     const m = RFC_FULL.exec(value);
//     if (!m) return value;
//     const month = MONTHS[m[2].toLowerCase()];
//     if (month === undefined) return value;
//     const p = (n) => String(n).padStart(2, "0");
//     return `${m[3]}-${p(month + 1)}-${p(m[1])}T${m[4]}:${m[5]}:${m[6]}`;
//   }
//   if (Array.isArray(value)) {
//     for (let i = 0; i < value.length; i++) {
//       value[i] = normalizeServerDates(value[i]);
//     }
//     return value;
//   }
//   if (value && typeof value === "object") {
//     const proto = Object.getPrototypeOf(value);
//     if (proto === Object.prototype || proto === null) {
//       for (const k of Object.keys(value)) {
//         value[k] = normalizeServerDates(value[k]);
//       }
//     }
//   }
//   return value;
// }

// // axios (global) veya axios.create() ile üretilmiş instance'a bir kez kurulur.
// export function installDateFix(instance) {
//   if (!instance || !instance.interceptors || instance.__dateFixInstalled)
//     return;
//   instance.__dateFixInstalled = true;
//   instance.interceptors.response.use((res) => {
//     if (res && res.data !== undefined)
//       res.data = normalizeServerDates(res.data);
//     return res;
//   });
// }
// utils/dateUtils.js
//
// ⚠️ Sorun: Flask, İstanbul duvar saatini "Sun, 11 Oct 2026 23:43:22 GMT"
// biçiminde döndürüyor. Tarayıcıdaki new Date() bunu gerçek UTC sanıp yerel
// saate (+3) çeviriyor → ekranda 3 saat kayma oluyor.
//
// ✅ Çözüm: Bu dosyadaki iki fonksiyon, sunucudan gelen tarihleri "saat dilimi
// dönüşümü YAPMADAN" okur. Yani "23:43 GMT" → "23:43 yerel" olarak alınır.
//
// Kullanım seçenekleri:
//   1) parseServerDate(input)  → tek bir tarihi Date objesine çevirir
//   2) installDateFix(axios)   → axios instance'ına kurulur, TÜM API
//                                yanıtlarındaki RFC tarihleri otomatik olarak
//                                "YYYY-MM-DDTHH:mm:ss" biçimine normalize edilir.
//                                Böylece bileşenlerde düz new Date() güvenli olur.
//
// İkisinden BİRİNİ seçin, ikisini birden kullanmak gereksizdir.

const MONTHS = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11,
};

// "Sun, 11 Oct 2026 23:43:22 GMT" veya "... UTC" veya etiketsiz
const RFC_RE =
  /^[A-Za-z]{3},\s*(\d{1,2})\s+([A-Za-z]{3})\s+(\d{4})\s+(\d{2}):(\d{2})(?::(\d{2}))?\s*(?:GMT|UTC)?$/i;

// "2026-10-11" veya "2026-10-11 23:43" veya "2026-10-11T23:43:22"
const SQL_RE = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/;

/**
 * Sunucudan gelen tarihi, saat dilimi dönüşümü YAPMADAN Date objesine çevirir.
 * "23:43 GMT" → 23:43 yerel saat olarak okunur (kayma olmaz).
 *
 * Her zaman bir Date döner. Çözülemezse Invalid Date döner
 * (isNaN(d.getTime()) kontrolü ile tespit edilir).
 */
export function parseServerDate(input) {
  if (input instanceof Date) return input;
  if (input === null || input === undefined || input === "") {
    return new Date(NaN);
  }

  const s = String(input).trim();

  // 1) RFC formatı (Flask'ın gönderdiği asıl format)
  const rfc = RFC_RE.exec(s);
  if (rfc) {
    const month = MONTHS[rfc[2].toLowerCase()];
    if (month !== undefined) {
      return new Date(
        +rfc[3], // yıl
        month, // ay (0-index)
        +rfc[1], // gün
        +rfc[4], // saat
        +rfc[5], // dakika
        +(rfc[6] || 0), // saniye
      );
    }
  }

  // 2) SQL / ISO (timezone'suz) formatı
  const sql = SQL_RE.exec(s);
  if (sql) {
    return new Date(
      +sql[1],
      +sql[2] - 1,
      +sql[3],
      +(sql[4] || 0),
      +(sql[5] || 0),
      +(sql[6] || 0),
    );
  }

  // 3) Diğer (Z veya +03:00 içeren ISO vb.) → tarayıcıya bırak
  return new Date(s);
}

/* ─────────────────────────────────────────────────────────────
 * Merkezi düzeltme (opsiyonel ama önerilen)
 * ─────────────────────────────────────────────────────────────
 * Axios instance'ına bir kez kurulur. Kurulduktan sonra API'den gelen
 * TÜM "Sun, 11 Oct 2026 23:43:22 GMT" tarihleri otomatik olarak
 * "2026-10-11T23:43:22" biçimine dönüştürülür (timezone'suz → yerel).
 * Böylece bileşenlerde düz `new Date(...)` bile doğru çalışır.
 *
 *     import axios from "axios";
 *     import { installDateFix } from "../../utils/dateUtils";
 *     const api = axios.create({ baseURL: "..." });
 *     installDateFix(api);
 */

const RFC_FULL =
  /^[A-Za-z]{3},\s*(\d{1,2})\s+([A-Za-z]{3})\s+(\d{4})\s+(\d{2}):(\d{2})(?::(\d{2}))?\s*(?:GMT|UTC)$/i;

/**
 * Bir string'i RFC tarihinden SQL benzeri stringe çevirir.
 * Çevrilemezse aynı string'i döner.
 */
function normalizeDateString(str) {
  const m = RFC_FULL.exec(str);
  if (!m) return str;

  const month = MONTHS[m[2].toLowerCase()];
  if (month === undefined) return str;

  const p = (n) => String(n).padStart(2, "0");
  return `${m[3]}-${p(month + 1)}-${p(m[1])}T${m[4]}:${m[5]}:${m[6] || "00"}`;
}

/**
 * İç içe objelerdeki / dizilerdeki TÜM RFC tarih stringlerini
 * "YYYY-MM-DDTHH:mm:ss" biçimine dönüştürür. Yerinde (in-place) çalışır.
 */
export function normalizeServerDates(value) {
  if (typeof value === "string") {
    return normalizeDateString(value);
  }

  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      value[i] = normalizeServerDates(value[i]);
    }
    return value;
  }

  if (value && typeof value === "object") {
    // Sadece düz objeleri gez; Date, FormData, Blob vb. dokunma
    const proto = Object.getPrototypeOf(value);
    if (proto === Object.prototype || proto === null) {
      for (const k of Object.keys(value)) {
        value[k] = normalizeServerDates(value[k]);
      }
    }
  }

  return value;
}

/**
 * Axios instance'ına interceptor kurar. Aynı instance'a iki kez
 * kurulmaz (idempotent).
 */
export function installDateFix(instance) {
  if (!instance || !instance.interceptors || instance.__dateFixInstalled) {
    return;
  }
  instance.__dateFixInstalled = true;

  instance.interceptors.response.use((res) => {
    if (res && res.data !== undefined) {
      res.data = normalizeServerDates(res.data);
    }
    return res;
  });
}
